const LOAD = 'GET_SURVEY_EXTRA_OPTIONS_LOAD';
const LOAD_SUCCESS = 'GET_SURVEY_EXTRA_OPTIONS_LOAD_SUCCESS';
const LOAD_FAIL = 'GET_SURVEY_EXTRA_OPTIONS_LOAD_FAIL';

const initialState = {
  loaded: false
};

export default function reducer(state = initialState, action = {}) {
  switch (action.type) {
    case LOAD:
      return {
        ...state,
        loading: true
      };
    case LOAD_SUCCESS:
      return {
        ...state,
        loading: false,
        loaded: true,
        data: action.result.options
      };
    case LOAD_FAIL:
      return {
        ...state,
        loading: false,
        loaded: false,
        error: action.error
      };
    default:
      return state;
  }
}

export function getExtraOptions(id, option) {
  return {
    types: [LOAD, LOAD_SUCCESS, LOAD_FAIL],
    promise: ({ client }) => client.get(`/v1/survey/extra-options?id=${id}&option=${option}`)
  };
}
